import { generatePath } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';

import { Link } from '@/components/ui/link';
import { StatsBox } from '@/modules/documents/view/components/pages/site-overview/stats-box';

export type CardTasksProps = {
  className?: string;
};

export function CardTasks({ className }: CardTasksProps) {
  const path = generatePath('/tasks');

  return (
    <StatsBox
      className={className}
      icon={{ element: <ClipboardList /> }}
      title="Open Tasks"
      value={5}
    >
      <StatsBox.Action>
        <Link to={path}>View Tasks</Link>
      </StatsBox.Action>
    </StatsBox>
  );
}
